import KeyboardDismissView from "@app/hoc/KeyboardDismissView"
import ScreenWrapper from "@app/hoc/ScreenWrapper"
import { PrivateStackParamList } from "@app/navigationApp/types"
import CommonHeader from "@app/sharedComponents/CommonHeader/CommonHeader"
import { ThemedView, Theme, themeColorSet } from "@app/theme"
import { ThemedText } from "@app/theme/Components"
import { NativeStackScreenProps } from "@react-navigation/native-stack"
import { ScrollView, Image, TouchableOpacity } from "react-native"
import Button from '@sharedComponents/Button/Button';
import { useState } from "react"
const FAQIMAGE = "https://volt-images-alpha.s3.ap-south-1.amazonaws.com/faq.png"
const HowItWorkImage = 'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/howItWorks.png'
import { useTheme } from '@shopify/restyle'
import { CaretRight } from '@app/sharedComponents/Icons/Icons';
import BottomSheetContainer from "@app/sharedComponents/Bottomsheet/Bottomsheet"
import HowItWorks from "../PleadgeMore/component/HowItWork"
import { usePledgeData } from "@app/hooks/usePledgeData"
import { addCommasToNumber} from "@voltmoney/micro-frontend"
import { useAppSelector } from "@app/store/hooks"
import { useCurrentApplicationDetails } from "@app/hooks/useCurrenApplicationDetails"
import PreFetchView from "./components/PreFetch"
import EditLimit from "./components/EditLimit"
import PostFetchView from "./components/PostFetchView"
import PageLoader from "@app/sharedComponents/PageLoader/PageLoader"
import { showHelpAndSupportField } from "@app/utils"
import ROUTE from '@app/navigationApp/routes';

type ManageLimitLandingPageProps = NativeStackScreenProps<PrivateStackParamList, 'MANAGE_LIMIT_LANDING'> & {

}

const ManageLimitLandingPage = ({
    navigation,
    route
}: ManageLimitLandingPageProps) => {

    const { userDetails } = useAppSelector(state => state.auth);
    const [showFaq, setShowFaq] = useState(false);
    const { pledgeData, loading } = usePledgeData();
    const { currentApplicationDetails, currentApplicationDetailsLoading } = useCurrentApplicationDetails()
    const { colors } = useTheme<Theme>();

    //save on slice
    const isFromEnhancedLimit = currentApplicationDetails?.isEnhanceLimitApplication;

    const isEditLimitEnabled = currentApplicationDetails?.isEditLimitEnabled;
    const applicationStage = currentApplicationDetails?.applicationStage;
    const showFaqs = userDetails?.linkedPlatformAccounts[0]?.platformSDKConfig?.showUserProfileFaq === true;
    const hideFaq = userDetails?.linkedPlatformAccounts[0]?.platformSDKConfig?.showUserProfileFaq === false
    const faqData = useAppSelector((state)=>state?.firebaseParams?.faqData);
    const parsedFaqData = JSON.parse(faqData||"{}");
    const faqParams = {
        item:'',
        title:''
    }
    parsedFaqData?.faqData?.forEach(item => {
        if (item.id === 'COLLATERAL') {
            faqParams.item = item?.cards;
            faqParams.title = item?.title;
        }
    });

    // const selectedCreditLimit = pledgeData?.stepResponseObject?.requestCreditLimit
    // const availableToUnlock = pledgeData?.stepResponseObject?.availableCreditLimit
    // const approvedCreditLimit = pledgeData?.data?.stepResponseObject?.additionalLimit
    // const existingCreditLimit = pledgeData?.data?.stepResponseObject?.existingSanctionedLimit

    const handleViewDetail = () => {
        navigation.navigate('PLEADGE_MF')
    }
    const handleFaqs = () => {
        console.log("faqParams",faqParams)
        if(showHelpAndSupportField(userDetails)) {
            navigation.navigate(ROUTE.FAQ_SCREEN_REVAMP,{...faqParams})
        }
        else navigation.navigate(ROUTE.FAQ)
    
    }

    if(currentApplicationDetailsLoading || loading){
        return <PageLoader />
    }

    return (
        <ScreenWrapper screenName={route.name}>
                <CommonHeader
                    label=''
                    //@ts-expect-error
                    navigation={navigation}
                    pageName={route.name}
                />
                <ScrollView
                    style={{ flex: 1, backgroundColor:themeColorSet['bg-surface-page'] }}
                    showsVerticalScrollIndicator={false}
                >
                    {
                        applicationStage === "PRE_FETCH" ?
                            <PreFetchView route={route} navigation={navigation} />
                            : isEditLimitEnabled
                                ? <EditLimit
                                    route={route}
                                    navigation={navigation}
                                    pledgeData={pledgeData}
                                /> :
                                <PostFetchView
                                    route={route}
                                    navigation={navigation}
                                    pledgeData={pledgeData}
                                    currentApplicationDetails={currentApplicationDetails}
                                />
                    }
                    <ThemedView flex={1} flexDirection="row" justifyContent="space-between" backgroundColor="white" style={{ padding: 16, marginBottom: 16 }} borderTopWidth={1} borderBottomWidth={1} borderTopColor={'border-secondary'} borderBottomColor={'border-secondary'}>
                        <ThemedView>
                            <ThemedText
                                variant="b3r"
                            >
                                Existing credit limit
                            </ThemedText>
                            <ThemedText
                                variant="b2s"
                                fontWeight="600"
                                color="text-success"
                            >
                                ₹{pledgeData?.stepResponseObject?.existingSanctionedLimit && addCommasToNumber(pledgeData?.stepResponseObject?.existingSanctionedLimit)}
                            </ThemedText>
                        </ThemedView>
                        <TouchableOpacity
                            onPress={() => {
                                handleViewDetail()
                            }}
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center'
                            }}
                        >
                            <ThemedText
                                variant="b2s"
                                color="text-action-primary"
                            >
                                View details
                            </ThemedText>
                            <CaretRight size="16" color={themeColorSet['text-action-primary']} />
                        </TouchableOpacity>
                    </ThemedView>
                        <TouchableOpacity onPress={() => { setShowFaq(true) }}>
                            <ThemedView style={{ padding: 16 }} flexDirection="row" justifyContent="space-between" backgroundColor="white" borderTopWidth={1} borderBottomWidth={hideFaq ? 1 : 0} borderTopColor={'border-secondary'} borderBottomColor={'border-secondary'}>
                                <ThemedView flexDirection="row" alignItems="center">
                                    <Image
                                        source={{
                                            uri: HowItWorkImage
                                        }}
                                        style={{
                                            height: 24,
                                            width: 24,
                                        }}
                                    />
                                    <ThemedText style={{ paddingLeft: 8 }} variant="b3r">
                                        How it works?
                                    </ThemedText>
                                </ThemedView>
                                <ThemedView flexDirection="row" alignItems="center">
                                    <CaretRight size="16" color={themeColorSet['text-action-primary']} />
                                </ThemedView>
                            </ThemedView>
                        </TouchableOpacity>
                    {
                        !hideFaq &&
                        <TouchableOpacity onPress={handleFaqs}>
                        <ThemedView style={{ padding: 16 }} flexDirection="row" justifyContent="space-between" backgroundColor="white" borderTopWidth={1} borderTopColor={'border-secondary'}> 
                            <ThemedView flexDirection="row" alignItems="center">
                                <Image
                                    source={{
                                        uri: FAQIMAGE
                                    }}
                                    style={{
                                        height: 24,
                                        width: 24,
                                    }}
                                />
                                <ThemedText style={{ paddingLeft: 8 }} variant="b3r">
                                    FAQs
                                </ThemedText>
                            </ThemedView>
                            <ThemedView flexDirection="row" alignItems="center">
                                <CaretRight size="16" color={themeColorSet['text-action-primary']} />
                            </ThemedView>
                        </ThemedView>
                        </TouchableOpacity>
                    }
                </ScrollView>
                <BottomSheetContainer
                    isVisible={showFaq}
                    closeOnBackdropPress={false}
                    showCloseIcon={true}
                    close={() => {
                        setShowFaq(false)
                    }}
                    onClose={() => {
                        setShowFaq(false)
                    }}
                    dragComponent={<ThemedView style={{ height: 12 }} />}
                    borderTopRightRadius={10}
                    borderTopLeftRadius={10}
                    containerStyle={{ borderTopRightRadius: 16, borderTopLeftRadius: 16 }}
                >
                    <ThemedView>
                        <ThemedView style={{ marginTop: 8 }} />
                        <HowItWorks />
                        <ThemedView style={{ paddingHorizontal: 16, paddingBottom: 16 }}>
                            <Button
                                eventName={route.name + '_GET_MY_PORTFOLIO'}
                                label={'Ok, got it!'}
                                handlePress={() => {
                                    setShowFaq(false)
                                }}
                                type={'SOLID'}
                                size='MD'
                                bg='bg-primary'
                                textColor='text-primary'
                            />
                        </ThemedView>
                    </ThemedView>
                </BottomSheetContainer>
        </ScreenWrapper>
    )
}

export default ManageLimitLandingPage;